import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { SHOULD_AUTH } from "../shared/interceptors/api-interceptor";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    // Add a dummy query parameter to force no caching on the translation files
    // until we have a proper cache-busting solution.
    return this.http.get<Translation>(`./translations/${lang}.json?t=${Date.now()}`, {
      context: new HttpContext().set(SHOULD_AUTH, false),
    });
  }
}
